import React from 'react';
import styled from 'styled-components';

type WrapperProps = {
  backgroundColor: string;
  textColor: string;
}

const ButtonWrapper = styled.button<WrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: ${({ theme, backgroundColor }) => (backgroundColor === 'transparent' ? `1px solid ${theme.colors.basic400}` : 'none')};
  outline: none;
  border-radius: 50px;
  padding: 20px 0;
  transition: opacity 0.3 ease-out;
  opacity: 1;
  margin: 5px 0;

  :hover {
    opacity: 0.9;
  }

  :focus {
    opacity: 0.8;
  }

  :disabled {
    opacity: 0.2;
  }
`;

type ButtonProps = {
  text: string;
  backgroundColor?: string;
  textColor: string;
  onClick?: () => void;
  disabled?: boolean;
}

const Button = ({
  text, backgroundColor, textColor, onClick, disabled = false,
}: ButtonProps) => (
  <ButtonWrapper
    disabled={disabled}
    backgroundColor={backgroundColor || 'transparent'}
    textColor={textColor}
    onClick={onClick}
  >
    {text}
  </ButtonWrapper>
);

export default Button;